<style lang="scss" scoped>
.lottery-window-one-wrapper{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  &-content{
    width:538px;
    height:560px;
    background:rgba(255,251,243,1);
    border-radius:16px;
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    &-close{
      width:48px;
      height:48px;
      position: absolute;
      top: -78px;
      right: 12px;
      background: url('./../assets/img/close.svg');
      background-size: cover;
      cursor: pointer;
      &::before{
        content: '';
        height: 30px;
        width: 2px;
        position: absolute;
        bottom: -30px;
        left: 50%;
        transform: translateX(-50%);
        background: #FFFBF3;
      }
    }
    &-header{
      background: url('./../assets/img/bg.svg') no-repeat;
      background-size: cover;
      width:538px;
      height:134px;
      border-radius:8px 8px 0px 0px;
      p{
        font-size:30px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:134px;
      }
    }
    &-footer{
      flex: 1;
      position: relative;
      overflow: hidden;
      &-center{
        position: absolute;
        top: 26px;
        left: 50%;
        transform: translateX(-50%);
        width:220px;
        height:220px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      &-code{
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 130px;
        text-align: center;
        font-size:16px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(77,77,77,1);
        line-height:17px;
      }
      button{
        border: none;
        outline: none;
        width: 255px;
        height: 57px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 27px;
        background: url('./../assets/img/btn.svg') no-repeat;
        background-size: cover;
        font-size:18px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(194,52,18,1);
        line-height:20px;
        cursor: pointer;
      }
    }
  }
  .mask{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background:rgba(0,0,0,1);
    opacity:0.6009;
  }
}

</style>

<template>
  <div v-show="ShowLotteryWindowTwo" class="lottery-window-one-wrapper">
    <div class="lottery-window-one-wrapper-content">
      <span @click="ShowLotteryWindowTwo = false" class="lottery-window-one-wrapper-content-close"></span>
      <div class="lottery-window-one-wrapper-content-header">
      <p>恭喜您中奖啦</p>
      </div>
      <div class="lottery-window-one-wrapper-content-footer">
        <div class="lottery-window-one-wrapper-content-footer-center">
          <img :src="prize.pic" alt="">
        </div>
        <p class="lottery-window-one-wrapper-content-footer-code">兑换码：{{prize.code}}</p>
        <button @click="copyCode">复制兑换码</button>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ShowLotteryWindowTwo: false,
      prize: {},
    }
  },
  props:{
    lotteryData: [Array, Object]
  },
  methods: {
    copyCode() {
      this.$copyText(this.prize.code).then(() => {
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          this.$toast({
          message: '复制成功',
          duration: 1500,
          type: 'success'
        })
        }, 500);
      });
    }
  },
  mounted() {
    this.$bus.on('ShowLotteryWindowTwo', (prize) => {
      this.prize = prize;
      this.ShowLotteryWindowTwo = true;
    })
    //解决滑动穿透
    const oLogin = document.querySelector('.lottery-window-one-wrapper');
    oLogin.addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, false);
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/LotteryWindowTwo.vue